__turbopack_context__.v({
  "className": "sacramento_b6e91c69-module__oJiRDW__className",
  "variable": "sacramento_b6e91c69-module__oJiRDW__variable",
});
